module.exports = __webpack_public_path__ + "img/12.6125a4c7.jpg";